import Environment from './Environment';
import { report } from '../report';
import { LanguageKey, defaultLanguageKey, fallbackLanguageKey } from './SDK/Language';
import { GameJSON } from '../GameJSON';
import { Logger } from './Logger/Logger';
import { LogStyles } from './Logger/LogStyles';

// TODO: refine the to actual possible keys
type TextKey = string;

export type LanguageData = {
    [textKey in TextKey]: {
        [locale in LanguageKey]: string;
    };
};

//

export default class LocaleManager {
    private languageData: LanguageData | null = null;
    private languageKey = defaultLanguageKey;
    private hasLocaleStorage: boolean = true;

    constructor() {
        let lang: LanguageData = {};

        try {
            lang = JSON.parse(GameJSON.lang);
        } catch (e) {
            console.warn(e);
        }

        // Set language data from main JSON data.
        this.languageData = lang;
    }

    public setLanguagePartialData(languageData: LanguageData) {
        for (let languageDataKey in languageData) {
            this.languageData[languageDataKey] = languageData[languageDataKey];
        }
    }

    public getLanguage(): string {
        return this.languageKey;
    }

    public setLanguage(languageKey: LanguageKey): void {
        if (!Object.values(LanguageKey).includes(languageKey)) {
            report('Ignoring unsupported locale', {
                once: true,
                sampleRate: 0.1,
                tags: {
                    currentLanguageKey: this.languageKey,
                    attemptedLanguageKey: languageKey,
                },
            });
            return;
        }
        this.languageKey = languageKey;
    }

    public getText(textKey: TextKey): string {
        if (!this.languageData) {
            report('Language data not available', { once: true, fingerprint: 'getText:LanguageDataMissing' });
            return textKey;
        }

        if (!this.languageData[textKey]) {
            report('Data for given localization key not found', {
                once: true,
                sampleRate: 0.1,
                tags: { textKey },
                fingerprint: 'getText:LocalizationKeyNotFound',
            });
            return textKey;
        }

        let languageKey: LanguageKey = this.languageKey;

        if (process?.env.NODE_ENV === Environment.DEVELOPMENT) {
            if (this.hasLocaleStorage) {
                try {
                    languageKey = (localStorage.getItem('debugForceLocale') as LanguageKey) ?? languageKey;
                } catch (error) {
                    Logger.log(error, undefined, LogStyles.ERROR);
                    this.hasLocaleStorage = false;
                    languageKey = this.languageKey;
                }
            }
        }

        return String(
            this.languageData[textKey][languageKey] || this.languageData[textKey][fallbackLanguageKey] || textKey
        );
    }
}
